import React from "react";

const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        id="ic24-plus"
        d="M13,4a1.125,1.125,0,0,1,1.125,1.125v6.75h6.75a1.125,1.125,0,0,1,0,2.25h-6.75v6.75a1.125,1.125,0,0,1-2.25,0v-6.75H5.125a1.125,1.125,0,0,1,0-2.25h6.75V5.125A1.125,1.125,0,0,1,13,4Z"
        transform="translate(-4 -4)"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default PlusIcon;
